import { Button } from '@talentmesh/ui/components/button';
import { TypographyH3 } from '@talentmesh/ui/components/typography';
import { ChevronLeft } from 'lucide-react';
import { generatePath, useNavigate } from 'react-router';
import { useCandidatesResultsContext } from '../../Contexts/CandidateResultsContext';
import CandidateFavorite from './Components/CandidateFavorite';
import { useRecruitmentId } from '@/Hooks';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';

function HeaderInfo() {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const assessmentId = useRecruitmentId();
    const { results } = useCandidatesResultsContext();
    const { candidateFirstName, candidateLastName } = results;
    const candidateOverviewPath = generatePath(RoutePath.CandidatesOverview, { companyId, assessmentId });

    return (
        <div className="flex flex-row items-center justify-start gap-2">
            <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => navigate(candidateOverviewPath)}
                aria-label="Back"
            >
                <ChevronLeft className="size-5" />
            </Button>
            <CandidateFavorite />
            <TypographyH3 className="text-foreground">
                {candidateFirstName} {candidateLastName}
            </TypographyH3>
        </div>
    );
}

export default HeaderInfo;
